import type { OnInit } from '@angular/core';
import { Component, HostListener, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';

import { environment } from '../../../../enviroment/enviroment';
import { UserPreferencesComponent } from '../../../core/user-preferences/user-preferences.component';
import { FooterComponent } from '../../../shared/footer/footer.component';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-web-layout',
  imports: [RouterModule, SharedModule, UserPreferencesComponent, FooterComponent],
  templateUrl: './web-layout.component.html',
  styleUrl: './web-layout.component.scss',
})
export class WebLayoutComponent implements OnInit {
  router = inject(Router);
  isStuck: boolean = false;
  isOurFleet: boolean = false;

  ngOnInit(): void {
    this.isOurFleet =
      this.router.url.includes('/our-fleet') ||
      this.router.url.includes('/terms-and-condition') ||
      this.router.url.includes('/privacy-policy');

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isOurFleet =
          event.urlAfterRedirects.includes('/our-fleet') ||
          event.urlAfterRedirects.includes('/terms-and-condition') ||
          event.urlAfterRedirects.includes('/privacy-policy');
      });
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    const SCROLL_TOP = window.scrollY || document.documentElement.scrollTop || 0;
    this.isStuck = SCROLL_TOP > 8;
  }

  onLogin(): void {
    if (typeof window !== 'undefined') {
      window.open(
        environment.ANGULAR_REDIRECT_URL + '/auth/login',
        '_blank',
        'noopener,noreferrer'
      );
    }
  }

  onSignup(): void {
    if (typeof window !== 'undefined') {
      window.open(
        environment.ANGULAR_REDIRECT_URL + '/auth/signup',
        '_blank',
        'noopener,noreferrer'
      );
    }
  }
}
